import React, { useContext, useState, useEffect } from "react";
import { separate } from "../tools/helper";
import {
  SetAddres,
  UserAddress,
  VerifyTakhfif,
  SetBasket,
  SetBasketDetail,
  ShippingAmount,
  UserDetail,
} from "../axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { CartContext } from "../components/shared/context/cart-context";
import { useLocation } from "react-router-dom";
import roundToNearestFiveThousand from "../tools/roundToNearestFiveThousand";
import { payBasket } from "./../axios";

const Card = () => {
  const [addressState, setAddressState] = useState({
    titleAddres: "",
    wholeAddres: "",
    lat: 0,
    long: 0,
    postalcode: "",
    name: "",
    family: "",
  });

  const addressChangeHandler = ({ target }) => {
    setAddressState((prevState) => {
      return {
        ...prevState,
        [target.name]: target.value,
      };
    });
  };
  const [addressid, setaddressid] = useState(null);

  const [takhfif, setTakfif] = useState("");
  const [isPrintedBook, setIsPrintedBook] = useState(false);
  const [listOfAddress, setListOfAddress] = useState([]);
  const [takhfifPrice, setTakhfifPrice] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [updatedCartItems, setUpdatedCartItems] = useState([]);

  // ------------------------------------------- CartContext
  const [cartItems, setCartItems] = useContext(CartContext);
  // -------------------------------------------
  //shipping amount
  const [shippingAmount, setshippingAmount] = useState(0);
  const [minFreeShipingAmount, setMinFreeShipingAmount] = useState(800000);
  //all the flashCarts
  const [flashCartContainer, setFlashCartContainer] = useState([]);
  //head flashCarts, we need one flashCart per subCategory to call setFlashCartDetail api
  const [mainFlashCarts, setMainFlashCarts] = useState([]);
  const [eligibleDiscountProducts, setEligibleDiscountProducts] = useState([]);

  console.log("shipping amount", shippingAmount);

  //handling flashCarts
  useEffect(() => {
    const flashCartArray = [
      ...cartItems.filter((item) => item.categoryID === 4),
    ];

    setFlashCartContainer(flashCartArray);

    // Get only one item per subcategoryID and calculate the subtotal price for each
    const uniqueSubcategoryItems = [];
    const seenSubcategories = new Set();
    const subcategoryTotals = {};

    flashCartArray.forEach((item) => {
      const { subCategoryID, price, priceTakhfif } = item;

      // If it's the first time seeing this subcategoryID, add the item to the result
      if (!seenSubcategories.has(subCategoryID)) {
        uniqueSubcategoryItems.push({
          ...item,
          subtotalPrice: 0,
          subtotalPriceTakhfif: 0,
        });
        seenSubcategories.add(subCategoryID);
      }

      // Accumulate the price and priceTakhfif for the subcategory
      if (!subcategoryTotals[subCategoryID]) {
        subcategoryTotals[subCategoryID] = { price: 0, priceTakhfif: 0 };
      }
      subcategoryTotals[subCategoryID].price += Number(price);
      subcategoryTotals[subCategoryID].priceTakhfif += Number(priceTakhfif);
    });

    uniqueSubcategoryItems.forEach((item) => {
      item.subtotalPrice = roundToNearestFiveThousand(
        subcategoryTotals[item.subCategoryID].price
      );
      item.subtotalPriceTakhfif = roundToNearestFiveThousand(
        subcategoryTotals[item.subCategoryID].priceTakhfif
      );
    });

    setMainFlashCarts(uniqueSubcategoryItems);
  }, [cartItems]);
  // console.log("maiiiiiin", mainFlashCarts);

  const submitAddres = (e) => {
    e.preventDefault();

    if (!addressState.titleAddres?.trim()) {
      toast.error("لطفا تمامی فیلد ها را کامل پر کنید.");
    } else if (!addressState.wholeAddres?.trim()) {
      toast.error("لطفا آدرس محل دریافت محصول را وارد نمایید.");
    } else if (!addressState.postalcode?.trim()) {
      toast.error("لطفا کد پستی محل دریافت مرسوله را وارد نمایید.");
      // } else if (!addressState.name) {
      //   toast.error("لطفا نام خود را وارد نمایید");
      // } else if (!addressState.family) {
      //   toast.error("لطفا نام خانوادگی خود را وارد نمایید");
    } else {
      SetAddres(
        localStorage.getItem("phonenumber"),
        addressState.titleAddres,
        addressState.wholeAddres,
        addressState.lat,
        addressState.long,
        addressState.postalcode,
        addressState.name,
        addressState.family
      ).then(({ data }) => {
        toast.success("اطلاعات آدرس به روزرسانی شد");
        getUserAddress();
      });
    }
  };

  const removeItemHandler = (e, value) => {
    e.preventDefault();

    if (value.categoryID === 4) {
      let filtered = cartItems.filter(
        (item) => item.subCategoryID != value.subCategoryID
      );
      setCartItems(filtered);

      let filtered2 = flashCartContainer.filter(
        (item) => item.subCategoryID === value.subCategoryID
      );
      setFlashCartContainer(filtered2);

      let filtered3 = mainFlashCarts.filter(
        (item) => item.subCategoryID === value.subCategoryID
      );
      setMainFlashCarts(filtered3);
    } else {
      setCartItems((prevCartItems) =>
        prevCartItems.filter((item) => item.id !== value.id)
      );
    }
  };

  const checkIsPrintedbook = () => {
    let existBookChapi =
      cartItems.some((item) => item?.categoryID === 1) ||
      cartItems.some((item) => item?.type === "fiziki");

    if (existBookChapi) {
      setIsPrintedBook(true);
    } else {
      setIsPrintedBook(false);
    }
  };

  useEffect(() => {
    checkIsPrintedbook();
    getUserAddress();

    setTotalAmount(
      cartItems.reduce(
        (accumulator, currentValue) =>
          Number(accumulator) + Number(currentValue.priceTakhfif),
        ""
      )
    );
  }, [cartItems]);

  const getUserAddress = () => {
    UserAddress(localStorage.getItem("phonenumber")).then(({ data }) => {
      data[data.length - 1]?.title &&
        data[data.length - 1]?.address1 &&
        data[data.length - 1]?.codePosti &&
        setAddressState({
          titleAddres: data[data.length - 1].title,
          wholeAddres: data[data.length - 1].address1,
          postalcode: data[data.length - 1].codePosti,
        });
      data.length && setListOfAddress(data);
      data[data.length - 1]?.id && setaddressid(data[data.length - 1].id);
    });

    // getting user name and family
    UserDetail(localStorage.getItem("phonenumber")).then(({ data }) => {
      if (data) {
        data[0]?.name &&
          data[0]?.family &&
          setAddressState((prevState) => {
            return {
              ...prevState,
              name: String(data[0]?.name) || "",
              family: String(data[0]?.family) || "",
            };
          });
      }
    });
  };

  //we check if the priceTakhfif of the product is lower than its price applyed the discount code
  //in that case we disable the discount code
  const checkCurrentTakhfif = (takhfifData) => {
    let productsApplyingDiscount = [];

    // Determine which products the discount applies to
    if (takhfifData[0].Products === "ALL") {
      productsApplyingDiscount = [...cartItems];
    } else {
      const productIds = takhfifData[0].Products.split("-");
      productsApplyingDiscount = cartItems.filter((item) =>
        productIds.some((id) => item.id == id)
      );
    }

    if (productsApplyingDiscount.length > 0) {
      let hasEligibleProduct = false; // Flag to check if at least one product can use the new discount
      let eligibleProducts = []; // Stores products that can get the new discount

      for (const product of productsApplyingDiscount) {
        const originalPrice = parseFloat(product.price);
        const currentDiscountedPrice = parseFloat(product.priceTakhfif);
        const newDiscountPercentage = parseFloat(takhfifData[0].PercentageINT);
        const newDiscountedPrice =
          originalPrice * (1 - newDiscountPercentage / 100);

        // If at least one product benefits from the new discount, set flag to true
        if (currentDiscountedPrice > newDiscountedPrice) {
          eligibleProducts.push(product);

          hasEligibleProduct = true;
        }
      }

      // Store eligible products in state before returning
      setEligibleDiscountProducts(eligibleProducts);

      // If all products have a better current discount, return false; otherwise, return true
      return hasEligibleProduct;
    }

    return false; // No applicable products, return false
  };

  // console.log("takhfifprice", takhfifPrice);

  const submitTakhfif = (e) => {
    e.preventDefault();
    try {
      VerifyTakhfif(takhfif).then(({ data }) => {
        if (data !== "-1" && data !== "0" && data.length) {
          // console.log("the takhfif ", data);
          if (data?.isKonkour) {
            toast.error("کد تخفیف نا معتبر میباشد");
          } else {
            const allowTakhfif = checkCurrentTakhfif(data);
            if (allowTakhfif) {
              setTakhfifPrice(data);
              toast.success(
                "کد تخفیف  برای کالاهای تخفیف دار ویژه این کد اعمال شد"
              );
            } else {
              toast.error(
                "تخفیف فعلی محصولات بیشتر از میزان تخفیف کد وارد شده میباشد"
              );
            }
          }
        } else {
          toast.error("کد تخفیف نا معتبر میباشد");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchShippingAmount = async () => {
      try {
        const response = await ShippingAmount();
        setshippingAmount(response.data[0].shippingAmount);
        setMinFreeShipingAmount(response.data[0].freeAmount);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchShippingAmount();
  }, []);

  const [takhfifState, setTakhfifState] = useState({
    discountPercentage: "",
    discountIds: [],
  });

  // console.log("the takhfif state is ", takhfifState);

  useEffect(() => {
    if (takhfifPrice.length > 0) {
      setTakhfifState({
        discountPercentage: takhfifPrice[0]?.PercentageINT,
        discountIds: takhfifPrice[0]?.Products?.split("-"),
      });
    }
  }, [takhfifPrice]);

  // console.log("takhffifififif" , eligibleDiscountProducts);

  const applyDiscount = (id, categoryID) => {
    // console.log("catId", categoryID);
    // Check if the product ID exists in the eligibleDiscountProducts array
    const isEligible = eligibleDiscountProducts.some(
      (product) => product.id === id
    );

    if (
      (takhfifState.discountIds.length < 1 ||
        takhfifState.discountIds === null ||
        takhfifState.discountIds?.map((str) => parseInt(str)).includes(id) ||
        takhfifState.discountIds.includes("ALL")) &&
      categoryID !== 10 &&
      isEligible
    ) {
      return (100 - takhfifState.discountPercentage) / 100;
    } else {
      return 1.0;
    }
  };

  // console.log("flash cart", takhfifState);

  //put the discounted price (with discount code) into the cartItems
  const newCartItems = cartItems.map((item) => {
    const discount = applyDiscount(item.id, item.categoryID);
    const finalPrice = discount === 1.0 ? item.priceTakhfif : item.price;

    return { ...item, finalPrice: finalPrice * discount };
  });

  const getTotalPrice = () => {
    let normalItemsPrice = 0;
    let flashCardsPrice = 0;

    if (flashCartContainer.length > 0) {
      cartItems
        .filter((item) => item.categoryID === 4)
        .forEach((item) => {
          const discount = applyDiscount(item.id, item.categoryID);

          // Choose the correct price based on the discount value
          const discountedPrice =
            discount === 1.0 ? item.priceTakhfif : item.price;

          flashCardsPrice += discountedPrice * discount;
        });
    }

    cartItems
      .filter((item) => item.categoryID !== 4)
      .forEach((item) => {
        const discount = applyDiscount(item.id, item.categoryID);
        // Choose the correct price based on the discount value
        const discountedPrice =
          discount === 1.0 ? item.priceTakhfif : item.price;

        // console.log("discountedPrice is", discountedPrice);
        normalItemsPrice += discountedPrice * discount;
      });

    const cleanFinalPrice =
      Number(normalItemsPrice) + roundToNearestFiveThousand(flashCardsPrice);
    return Number(cleanFinalPrice.toFixed(0));
  };

  // this grouping items by same id implemented to calculate count for chapi books
  const groupBy = (array, key) => {
    return array.reduce((result, currentItem) => {
      (result[currentItem[key]] = result[currentItem[key]] || []).push(
        currentItem
      );
      return result;
    }, {});
  };

  //delete all the flash carts and add only one flashCart per subcategory
  const nonFlashCartItems = cartItems.filter((item) => item.categoryID !== 4);
  const flashCartHeadsAdded = [...nonFlashCartItems, ...mainFlashCarts];
  const groupedCartItems = groupBy(flashCartHeadsAdded, "id");
  // ---------------------------------------------
  const [loading, setloading] = useState(false);

  const submitPayment = async (e) => {
    e.preventDefault();

    if (totalAmount === 0 || cartItems.length === 0) {
      return toast.error("مبلغ محصول صفر است");
    }

    if (
      isPrintedBook &&
      (addressState.titleAddres === "" ||
        addressState.wholeAddres === "" ||
        addressState.postalcode === "" ||
        // !addressState.name ||
        // !addressState.family ||
        !addressid)
    ) {
      return toast.error(
        "لطفا اطلاعات هویتی و آدرس خود را کامل کنید و دکمه ذخیره را بزنید"
      );
    }
    setloading(true);

    try {
      const basketData = await SetBasket(
        localStorage.getItem("phonenumber"),
        isPrintedBook ? addressid : "0",
        getTotalPrice() <= minFreeShipingAmount && isPrintedBook
          ? Number(getTotalPrice()) + Number(shippingAmount) + "0"
          : getTotalPrice() + "0",
        getTotalPrice() <= minFreeShipingAmount && isPrintedBook
          ? Number(getTotalPrice()) + Number(shippingAmount) + "0"
          : getTotalPrice() + "0",
        takhfif,
        takhfifPrice.length <= 1 ? false : true,
        " ",
        isPrintedBook && getTotalPrice() <= minFreeShipingAmount
          ? shippingAmount + "0"
          : 0,
        cartItems && cartItems.some((item) => item.isMoshaverePackage)
          ? true
          : false
      );

      // console.log("setBasket called", basketData);
      setloading(false);

      const groupedCartItemsValues = Object.values(groupedCartItems);

      //group the products , so when user purchase one book multiple , we calculate the count
      const promises = groupedCartItemsValues.map(async (group) => {
        const productid = group[0].id;
        const count = group.length;
        const finalPrice =
          newCartItems.find((item) => item.id === productid)?.finalPrice || 0;
        // console.log("new iteeeeeeeeeeeems" , productid);

        // Call API function
        await SetBasketDetail(
          localStorage.getItem("phonenumber"),
          basketData.data,
          productid,
          count,
          finalPrice
        );
      });
      // console.log("basketID", basketData.data);

      const res = await Promise.all(promises);

      if (res.length > 0) {
        const amount =
          isPrintedBook && getTotalPrice() <= minFreeShipingAmount
            ? Number(getTotalPrice()) + Number(shippingAmount) + "0"
            : Number(getTotalPrice()) + "0";
        if (
          amount == 0 &&
          takhfifState.discountIds &&
          takhfifState.discountPercentage == 100
        ) {
          try {
            console.log("called");

            const { data } = await payBasket(basketData.data);
            // console.log("data", data);

            if (data !== "-1") {
              toast.success("محصولات این سبد برای شما فعال شد");
            } else {
              toast.error("خطای ارتباط");
            }
          } catch (error) {
            toast.error("خطای ارتباط", error.message);
          }
        } else {
          window.open(
            `https://atropine.ir/api/Payment.aspx?basketid=${basketData.data}&amount=${amount}`,
            "_self",
            "noopener,noreferrer,resizable"
          );
        }
      }
    } catch (error) {
      console.error("the error is", error);
    }
  };

  const { pathname } = useLocation();

  useEffect(() => {
    const countedItem = {};
    cartItems.forEach((item) => {
      if (countedItem[item.id]) {
        countedItem[item.id].count++;
      } else {
        countedItem[item.id] = {
          ...item,
          count: 1,
        };
      }
    });

    let updatedCartItems = Object.values(countedItem);
    setUpdatedCartItems(updatedCartItems);
    // console.log("countedItem=> ", countedItem);
  }, [cartItems]);

  // decrement count product in shopping-cart
  const decrementProduct = (e, productIndex, productId) => {
    e.preventDefault();

    if (updatedCartItems[productIndex].count > 1) {
      let copyUpdateProducts = [...updatedCartItems];

      setUpdatedCartItems(copyUpdateProducts, {
        count: updatedCartItems[productIndex].count--,
      });

      let findProductIndex = cartItems.findIndex(
        (product) => product.id === productId
      );

      setCartItems(
        cartItems.filter((item, index) => index !== findProductIndex)
      );
    }
  };

  // increment count product in shopping-cart
  const incrementProduct = (e, productIndex) => {
    e.preventDefault();

    let copyUpdateProducts = [...updatedCartItems];

    setUpdatedCartItems(copyUpdateProducts, {
      count: updatedCartItems[productIndex].count++,
    });
    setCartItems((prevCartItems) => [
      ...prevCartItems,
      copyUpdateProducts[productIndex],
    ]);
  };

  //getting jameKol price for card
  const getJameKolPrice = (key) => {
    let normalItemsPrice = 0;
    let flashCardsPrice = 0;

    if (flashCartContainer?.length > 0) {
      flashCardsPrice = cartItems
        ?.filter((item) => item?.categoryID === 4)
        ?.reduce((accumulator, item) => {
          return (
            accumulator +
            (key === "price" ? Number(item?.price) : Number(item?.priceTakhfif))
          );
        }, 0);
    }

    normalItemsPrice = cartItems
      ?.filter((item) => item?.categoryID !== 4)
      ?.reduce((accumulator, item) => {
        return (
          accumulator +
          (key === "price" ? Number(item?.price) : Number(item?.priceTakhfif))
        );
      }, 0);

    return normalItemsPrice + roundToNearestFiveThousand(flashCardsPrice);
  };

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  // console.log("cartItems: ", updatedCartItems);

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <a href="/">خانه</a>
                  </li>
                  <li>سبد خرید</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {localStorage.getItem("phonenumber") ? (
        <div className="shopping_cart_area mt-60">
          <div className="container">
            <form onSubmit={submitPayment}>
              <div className="row">
                <div className="col-12">
                  <div className="table_desc">
                    <div className="cart_page table-responsive">
                      <table>
                        <thead>
                          <tr>
                            <th className="product_remove">حذف</th>
                            <th className="product_thumb">تصویر</th>
                            <th className="product_name">محصول</th>
                            <th className="product-price">قیمت</th>
                            <th className="product-price">قیمت با تخفیف</th>
                            <th className="product-price">تعداد</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mainFlashCarts?.length > 0 &&
                            mainFlashCarts.map((item) => (
                              <tr key={item?.id}>
                                <td className="product_remove">
                                  <button
                                    className="btn text-danger"
                                    onClick={(e) => removeItemHandler(e, item)}
                                  >
                                    <i className="fa fa-trash-o"></i>
                                  </button>
                                </td>
                                <td className="product_thumb">
                                  <div>
                                    <img
                                      src={item?.img}
                                      alt=""
                                      style={{
                                        height: "80px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                </td>
                                <td className="product_name">
                                  <p>{item.subCategoryTitle}</p>
                                </td>

                                <td className="product-price">
                                  {item?.subtotalPrice}
                                  تومان
                                </td>
                                <td className="product-price">
                                  {item?.subtotalPriceTakhfif}
                                  تومان
                                </td>
                              </tr>
                            ))}
                          {updatedCartItems.map(
                            (item, index) =>
                              item.categoryID !== 4 && (
                                <tr key={index}>
                                  <td className="product_remove">
                                    <button
                                      className="btn text-danger"
                                      onClick={(e) =>
                                        removeItemHandler(e, item)
                                      }
                                    >
                                      <i className="fa fa-trash-o"></i>
                                    </button>
                                  </td>
                                  <td className="product_thumb">
                                    <div>
                                      <img
                                        src={item.img}
                                        alt=""
                                        style={{
                                          height: "80px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td className="product_name">
                                    <Link to={`/product/${item.id}`}>
                                      {item.title}
                                    </Link>
                                  </td>

                                  <td className="product-price">
                                    {separate(item.price)} تومان
                                  </td>

                                  <td className="product-price">
                                    {separate(item.priceTakhfif)} تومان
                                  </td>

                                  <td className="product-price">
                                    <>
                                      {item?.type === "fiziki" ? (
                                        <button
                                          className="product-count__plus"
                                          onClick={(event) =>
                                            incrementProduct(event, index)
                                          }
                                        >
                                          +
                                        </button>
                                      ) : null}
                                      <input
                                        type="number"
                                        min={1}
                                        className="product-count__input"
                                        value={item.count}
                                      />
                                      {item?.type === "fiziki" ? (
                                        <button
                                          className="product-count__minus"
                                          onClick={(event) =>
                                            decrementProduct(
                                              event,
                                              index,
                                              item.id
                                            )
                                          }
                                        >
                                          -
                                        </button>
                                      ) : null}
                                    </>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="coupon_area">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="coupon_code left">
                      <h3>کد تخفیف</h3>
                      <div className="coupon_inner">
                        <p>کد تخفیف خود را در صورت وجود وارد نمایید</p>
                        <input
                          id="takhfifInput"
                          value={takhfif}
                          onChange={(e) => setTakfif(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              submitTakhfif(e);
                            }
                          }}
                          placeholder="کد تخفیف"
                          type="text"
                        ></input>
                        <button
                          id="takhfifBtn"
                          onClick={(e) => submitTakhfif(e)}
                          type="button"
                        >
                          اعمال کد تخفیف
                        </button>
                      </div>
                    </div>

                    {isPrintedBook && (
                      <div className="coupon_code left">
                        <h3>آدرس</h3>
                        <div className="coupon_inner">
                          <div className="login">
                            <div className="login_form_container">
                              <div className="account_login_form">
                                <form>
                                  <span className="text-danger fs-6">
                                    پس از ذخیره آدرس از این قسمت آدرس خود را
                                    انتخاب نمایید
                                  </span>

                                  <select
                                    onChange={(e) => {
                                      setAddressState({
                                        titleAddres:
                                          listOfAddress[e.target.value].title,
                                        wholeAddres:
                                          listOfAddress[e.target.value]
                                            .address1,
                                        postalcode:
                                          listOfAddress[e.target.value]
                                            .codePosti,
                                      });
                                      setaddressid(
                                        listOfAddress[e.target.value].id
                                      );
                                    }}
                                    // onChange={(e) => {
                                    //   settitleAddres(listOfAddress[e.target.value].title);
                                    //   setwholeAddres(listOfAddress[e.target.value].address1);
                                    //   setpostalcode(listOfAddress[e.target.value].codePosti);
                                    //   setaddressid(listOfAddress[e.target.value].id);
                                    // }}
                                  >
                                    {listOfAddress.map((item, index) => (
                                      <option value={index}>
                                        {item.title}
                                      </option>
                                    ))}
                                  </select>
                                  <br />
                                  <label className="mt-3">عنوان آدرس </label>
                                  <div class="d-flex w-100">
                                    <input
                                      className="w-75"
                                      name="titleAddres"
                                      value={addressState.titleAddres}
                                      onChange={addressChangeHandler}
                                      type="text"
                                      required
                                    ></input>
                                    <div className="save_button primary_btn default_button">
                                      <button
                                        onClick={(e) => submitAddres(e)}
                                        type="submit"
                                      >
                                        ذخیره اطلاعات
                                      </button>
                                    </div>
                                  </div>
                                  <label>استان ، شهرستان و آدرس کامل</label>
                                  <textarea
                                    name="wholeAddres"
                                    value={addressState.wholeAddres}
                                    onChange={addressChangeHandler}
                                    required
                                  ></textarea>
                                  <label>کد پستی</label>
                                  <input
                                    type="text"
                                    name="postalcode"
                                    value={addressState.postalcode}
                                    onChange={addressChangeHandler}
                                    required
                                  ></input>
                                  <label>نام</label>
                                  <input
                                    type="text"
                                    name="name"
                                    value={addressState.name}
                                    onChange={addressChangeHandler}
                                    required
                                  ></input>
                                  <label>نام خانوادگی</label>
                                  <input
                                    type="text"
                                    name="family"
                                    value={addressState.family}
                                    onChange={addressChangeHandler}
                                    required
                                  ></input>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="coupon_code right">
                      <h3>مجموع سبد</h3>
                      <div className="coupon_inner">
                        <div className="cart_subtotal">
                          <p>جمع کل</p>
                          <p className="cart_amount">
                            {separate(getJameKolPrice("price"))}
                            تومان
                          </p>
                        </div>
                        <div className="cart_subtotal">
                          <p>جمع کل با تخفیف</p>
                          <p className="cart_amount">
                            {separate(getJameKolPrice("priceTakhfif"))}
                            تومان
                          </p>
                        </div>
                        {/* ------------------------------ قیمت با تخفیف ------------------- */}

                        {takhfifState.discountPercentage !== "" && (
                          <div className="cart_subtotal">
                            <p>جمع کل با کد تخفیف</p>
                            <p className="cart_amount">
                              {totalAmount <= minFreeShipingAmount &&
                              isPrintedBook
                                ? separate(Number(getTotalPrice()))
                                : separate(getTotalPrice())}
                              تومان
                            </p>
                          </div>
                        )}

                        <div className="cart_subtotal ">
                          <p>هزینه ارسال</p>

                          <p className="cart_amount">
                            {getTotalPrice() <= minFreeShipingAmount &&
                            isPrintedBook
                              ? separate(shippingAmount)
                              : 0}
                            تومان
                          </p>
                        </div>
                        {/* <a href="#">محاسبه هزینه</a> */}

                        <div className="cart_subtotal has-border">
                          <p>مبلغ قابل پرداخت</p>
                          <p className="cart_amount">
                            {/* {isPrintedBook ? separate(totalAmount + 25000) : separate(totalAmount)} */}
                            {getTotalPrice() <= minFreeShipingAmount &&
                            isPrintedBook
                              ? separate(
                                  Number(getTotalPrice()) +
                                    Number(shippingAmount)
                                )
                              : separate(getTotalPrice())}
                            تومان
                          </p>
                        </div>

                        {/* -------------------------------- */}
                        <div className="checkout_btn">
                          {loading ? (
                            <div class="lds-spinner">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              disabled={loading}
                              style={{
                                color: "white",
                                minWidth: 40,
                                textAlign: "center",
                              }}
                            >
                              پرداخت
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <p className="text-danger fs-3 mt-3 me-3">
          ابتدا وارد حساب کاربری خود شوید!
        </p>
      )}
    </React.Fragment>
  );
};

export default Card;
